// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "stock_take_item".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "stock_take_item" table (1:1 with a DB row, on the wire). */
export const stockTakeItemAtomSchema = z.object({
    id: z.string(),
    stockTakeId: z.string(),
    productId: z.string(),
    expectedQuantity: z.number(),
    countedQuantity: z.number().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=stockTakeItem.js.map